<template>
  <div class="mt-5">
    <TabFirst :type="type" :windowType="windowType" :content="curData"></TabFirst>
  </div>
</template>

<script>
import TabFirst from '@/components/TabFirst'

export default {
  name: 'DataTag',
  components: {
    TabFirst
  },
  props: {
    type: Number,
    windowType: Boolean
  },
  data () {
    return {
      activeName: ''
    }
  },
  computed: {
    imageData () {
      return [
        {
          icon: 'data/icon/icn-image1',
          name: this.$t('data.img1'),
          alt: 'icn-image1',
          video: 'data/video/image1',
          gif: 'data/gif/image1'
        },
        {
          icon: 'data/icon/icn-image2',
          name: this.$t('data.img2'),
          alt: 'icn-image2',
          video: 'data/video/image2',
          gif: 'data/gif/image2'
        },
        {
          icon: 'data/icon/icn-image3',
          name: this.$t('data.img3'),
          alt: 'icn-image3',
          video: 'data/video/image3',
          gif: 'data/gif/image3'
        },
        {
          icon: 'data/icon/icn-image4',
          name: this.$t('data.img4'),
          alt: 'icn-image4',
          video: 'data/video/image4',
          gif: 'data/gif/image4'
        },
        {
          icon: 'data/icon/icn-image5',
          name: this.$t('data.img5'),
          alt: 'icn-image5',
          video: 'data/video/image5',
          gif: 'data/gif/image5'
        },
        {
          icon: 'data/icon/icn-image6',
          name: this.$t('data.img6'),
          alt: 'icn-image6',
          video: 'data/video/image6',
          gif: 'data/gif/image6'
        }
      ]
    },
    wavData () {
      return [
        {
          icon: 'data/icon/icn-wav1',
          name: this.$t('data.wav1'),
          alt: 'icn-wav1',
          video: 'data/video/wav1',
          gif: 'data/gif/wav1'
        },
        {
          icon: 'data/icon/icn-wav2',
          name: this.$t('data.wav2'),
          alt: 'icn-wav2',
          video: 'data/video/wav2',
          gif: 'data/gif/wav2'
        }
      ]
    },
    textData  () {
      return [
        {
          icon: 'data/icon/icn-text1',
          name: this.$t('data.text1'),
          alt: 'icn-text1',
          video: 'data/video/text1',
          gif: 'data/gif/text1'
        },
        {
          icon: 'data/icon/icn-text2',
          name: this.$t('data.text2'),
          alt: 'icn-text2',
          video: 'data/video/text2',
          gif: 'data/gif/text2'
        }
      ]
    },
    videoData () {
      return [
        {
          icon: 'data/icon/icn-video1',
          name: this.$t('data.video1'),
          alt: 'icn-video1',
          video: 'data/video/video1',
          gif: 'data/gif/video1'
        },
        {
          icon: 'data/icon/icn-video2',
          name: this.$t('data.video2'),
          alt: 'icn-video2',
          video: 'data/video/video2',
          gif: 'data/gif/video2'
        }
      ]
    },
    curData () {
      let res = []
      switch (this.type) {
        case 1:
          res = this.imageData
          break
        case 2:
          res = this.wavData
          break
        case 3:
          res = this.textData
          break
        case 4:
          res = this.videoData
          break
      }
      return res
    }
  }
}
</script>
